// @core/api/endpoints/tag/update_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TagResponse,
  UpdateTagRequest,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Update tag
 * Updates tag properties: name, color, icon, description. Does not affect existing assignments.
 */
export async function UpdateTag(
  tag_id: string,
  data: UpdateTagRequest,
  options?: RequestOptions
): Promise<TagResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tags/:tag_id`;
  requestPath = requestPath.replace(':tag_id', encodeURIComponent(tag_id));
  const requestOptions = options;
  return client.put<TagResponse>(requestPath, data, requestOptions);
}
